import React, { type ChangeEvent, useState, useEffect, useRef } from 'react'
import {
  Alert,
  Snackbar,
  Avatar,
  Button,
  IconButton,
  InputBase,
  type InputBaseProps,
  Stack,
  Typography,
  styled,
  alpha,
  CircularProgress,
  Box,
  TextField,
  useMediaQuery,
} from '@mui/material'
import type { AlertColor } from '@mui/material/Alert'
import LoadingMessages from '../SendMessage/loadingMessages/LoadingMessages'
import LoadingButton from '@mui/lab/LoadingButton'
import { EditIcon } from '../../../../components/Icons'
import { useSidebarContext } from '../../../../contexts/Old_SidebarContext'
// import Stepper from '../Messages/Actions/Stepper'

const StyledInputBase = styled(InputBase)<InputBaseProps>(({ theme }) => ({
  backgroundColor: theme.palette.common.white,
  borderWidth: 0.5,
  borderColor: theme.palette.text.primary,
  '& .MuiInputAdornment-positionEnd': {
    paddingRight: theme.spacing(1.5),
    [theme.breakpoints.down('sm')]: {
      paddingRight: theme.spacing(0), // Smaller padding for 'sm' screen size
    },
  },
  '& .MuiInputBase-input': {
    [theme.breakpoints.down('sm')]: {
      padding: '13px 5px', // Adjust padding for mobile if needed
    },
  },
}))

interface Props {
  question: any
  index: any
  questionId: any
}

const Question = ({ question, questionId, index }: Props) => {
  // console.log('question', question, questionId)
  const userId: number = sessionStorage.getItem('userId') as unknown as number
  const [isEdit, setEdit] = useState<boolean>(false)
  const [questionIdBeingEdited, setQuestionIdBeingEdited] = useState<string | null>(null)
  const [inputValue, setInputValue] = useState<string>(question)
  const questionRef = useRef<HTMLInputElement>(null)
  // const isPaid = sessionStorage.getItem('isPaid')

  const isMobile = useMediaQuery('(max-width: 600px)')
  // Snackbar
  const [snackbarOpen, setSnackbarOpen] = useState(false)
  const [snackbarMessage, setSnackbarMessage] = useState('')
  const [snackbarSeverity, setSnackbarSeverity] = useState<AlertColor | undefined>(undefined)

  const {
    isQuestionUpdating,
    setIsQuestionUpdating,
    fetchServerResponse,
    userStatus,
    handleSearchCount,
    setIsLoading,
    setQuestionId,
    setUserInput,
    setUpdateQuestion,
  } = useSidebarContext()

  // useEffect(() => {
  //   setIsLoading(true)
  // }, [])

  useEffect(() => {
    // isEdit && setInputValue(question)
    // console.log('question', question)
    if (isEdit && questionRef.current) {
      questionRef.current.value = question
    }
  }, [isEdit])

  // useEffect(() => {
  //   if (question) {
  //     setInputValue(question)
  //   }
  // }, [question])

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false)
  }

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value)
    setUserInput(event.target.value) // Update the message state
  }

  const handleUpdate = async (questionId: any) => {
    // console.log('questionId', questionId)

    const promptValue = questionRef?.current?.value ?? ''
    // console.log('questionRef?.current?.value', questionRef?.current?.value)
    // promptValue && console.log('promptValue', promptValue)
    setIsQuestionUpdating(true)
    setEdit(false)
    // onUpdate(inputValue)
    if (userId) {
      userStatus(userId)
      const uStatus: any = await userStatus(userId)
      if (uStatus?.status === false) {
        setSnackbarMessage('Something is wrong with user current status, please contact support !')
        setSnackbarSeverity('error')
        setSnackbarOpen(true)
        setIsQuestionUpdating(false)
      } else {
        const handleSearchCountResponse = await handleSearchCount(promptValue, userId)
        if (handleSearchCountResponse && promptValue) {
          // const isUpdated = await fetchServerResponse(questionRef.current?.value)
          const isUpdated = await fetchServerResponse(promptValue)
          // const isUpdated = await fetchServerResponse(questionRef.current!.value)
          if (isUpdated) {
            // console.log('question updated successfully', isUpdated)
            setSnackbarMessage('Question updated successfully')
            setSnackbarSeverity('success')
            setSnackbarOpen(true)
            setIsQuestionUpdating(false)
            setQuestionIdBeingEdited(null)
          }
        } else {
          setSnackbarSeverity('error')
          setIsQuestionUpdating(false)
          setSnackbarOpen(true)
        }
      }
    } else {
      setSnackbarMessage('User credentials are not found, please logout and login again')
      setSnackbarSeverity('warning')
      setSnackbarOpen(true)
    }

    setQuestionId(questionId)
  }

  const toggleClick = (qId: any): ((event: React.MouseEvent<HTMLElement>) => void) => {
    return (event: React.MouseEvent<HTMLElement>) => {
      setEdit(!isEdit)
      setQuestionIdBeingEdited(qId)
      setUpdateQuestion(true)
    }
  }

  // const token = sessionStorage.getItem('token')

  return (
    <div style={{ position: 'relative' }}>
      {isQuestionUpdating && questionIdBeingEdited === questionId && (
        <div
          style={{
            width: '100%',
            position: 'absolute',
            top: '-20px',
            right: '0px',
            zIndex: 1000,
            // backgroundColor: 'rgba(202, 92, 92, 0.5)',
          }}
        >
          {!isMobile && (
            <p style={{ color: 'green', textAlign: 'right' }}>
              Creating a response based on your edited prompt...
            </p>
          )}

          {/* <Box
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <CircularProgress disableShrink color='primary' thickness={4} />
          </Box> */}
        </div>
      )}
      <Stack spacing={1}>
        <Stack
          direction='row'
          alignItems='center'
          justifyContent='space-between'
          sx={{
            pt: 1,
            pb: 0,
            pl: 2,
            pr: 2,
          }}
          spacing={1.5}
        >
          <Stack direction='row' alignItems='center' flexGrow={1} spacing={2}>
            <Avatar variant='square' sx={{ bgcolor: '#587DBD' }}>
              RT
            </Avatar>
            {!isEdit && (
              <Typography variant='subtitle2' color='textSecondary'>
                {question}
              </Typography>
            )}
            {/* {isEdit && <StyledInputBase value={inputValue} onChange={handleChange} />} */}
            {isEdit && (
              <StyledInputBase
                multiline
                // rows={isMobile ? 2 : 1}
                fullWidth
                inputRef={questionRef}
                sx={{
                  '& .MuiInputBase-input': {
                    padding: '5px',
                  },
                  '& .MuiInputBase-input::placeholder': {
                    color: '#666 !important',
                    opacity: 0.4,
                  },
                }}
              />
              // <TextField
              //   multiline={isMobile}
              //   rows={isMobile ? 2 : 1}
              //   fullWidth
              //   inputRef={questionRef}
              // />
            )}
          </Stack>
          {/* <Stepper /> */}
          <IconButton sx={{ p: 0.5, color: 'background.border' }} onClick={toggleClick(questionId)}>
            <EditIcon />
          </IconButton>
        </Stack>
        {isQuestionUpdating && questionIdBeingEdited === questionId && (
          <LoadingMessages isLoading={isQuestionUpdating} />
        )}
        {isMobile && isQuestionUpdating && questionIdBeingEdited === questionId && (
          <p style={{ color: 'green', fontSize: '12px' }}>
            Creating a response based on your edited prompt...
          </p>
        )}

        {isEdit && (
          <>
            <Stack direction='row' spacing={3} justifyContent='flex-end'>
              <Button
                variant='outlined'
                sx={{ p: 0, width: 94, height: 40 }}
                onClick={toggleClick(questionId)}
              >
                Cancel
              </Button>
              <LoadingButton
                variant='contained'
                sx={{ p: 0, width: 96, height: 40 }}
                onClick={() => {
                  handleUpdate(questionId)
                }}
              >
                Update
              </LoadingButton>
            </Stack>
          </>
        )}
      </Stack>
      {snackbarOpen && (
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={snackbarOpen}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          sx={{ zIndex: '15000' }}
        >
          <Alert elevation={6} onClose={handleCloseSnackbar} severity={snackbarSeverity}>
            {snackbarMessage}
          </Alert>
        </Snackbar>
      )}
    </div>
  )
}

export default Question
